import React from "react";
import "./Mbrjourney.css";

const Mbrjourney = () => {
  return (
    <section className="journey-section">
      <div className="journey-overlay"></div>

      <div className="journey-container">
        <h2 className="journey-heading">
          From One Learner’s Dream <br /> to a Growing Community
        </h2>

        <p className="journey-text">
          What began as a simple vision by{" "}
          <span className="highlight">Bharath Reddy</span> — a passionate
          learner who once struggled to find his first break — has now evolved
          into a powerful movement that inspires and supports thousands of
          freshers across India.
          <br />
          <br />
          During his early career, Bharath faced challenges that every student
          experiences — lack of guidance, unclear career direction, and limited
          access to real opportunities. Instead of stopping there, he turned his
          journey into inspiration and built
          <strong> MBR Network’s</strong> — a platform dedicated to helping
          others succeed faster and smarter.
          <br />
          <br />
          Today, <strong>MBR Network’s</strong> is more than just a platform —
          it’s a
          <span className="keyword">
            {" "}
            community of learners, mentors, and achievers
          </span>
          working together to bridge the gap between talent and industry.
          Through real-world training, resume reviews, mock interviews, and live
          sessions, we’ve helped hundreds of students{" "}
          <span className="highlight">
            land their first job with confidence.
          </span>
          <br />
          <br />
          The journey continues — growing every day with a single mission:
          <span className="keyword">
            {" "}
            empowering every fresher to believe in their potential.
          </span>
        </p>

        <div className="journey-timeline">
          <div className="timeline-item">
            <div className="circle"></div>
            <div className="timeline-content">
              <h3>2020 — The Idea Begins</h3>
              <p>
                Bharath started mentoring small groups of students and realized
                the power of structured guidance.
              </p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="circle"></div>
            <div className="timeline-content">
              <h3>2022 — MBR Network’s Founded</h3>
              <p>
                The idea became a platform — connecting freshers with mentors,
                HRs, and real-world projects.
              </p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="circle"></div>
            <div className="timeline-content">
              <h3>2024 — 500+ Students Mentored</h3>
              <p>
                Through workshops, LinkedIn sessions, and interview training,
                the community saw real success stories.
              </p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="circle"></div>
            <div className="timeline-content">
              <h3>2025 — A Trusted Career Network</h3>
              <p>
                Today, MBR Network’s continues to grow, shaping the future of
                young professionals across industries.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mbrjourney;
